import { render, staticRenderFns } from "./modal-whatsapp-help.vue?vue&type=template&id=5a088b8a&scoped=true&"
import script from "./modal-whatsapp-help.vue?vue&type=script&lang=js&"
export * from "./modal-whatsapp-help.vue?vue&type=script&lang=js&"
import style0 from "./modal-whatsapp-help.vue?vue&type=style&index=0&id=5a088b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a088b8a",
  null
  
)

export default component.exports